import apiReq from 'core/api';
import type {
  YandexTrackerSearchTasksRequest,
  YandexTrackerSearchTasksResponse,
  YandexTrackerSaveTasksRequest,
  YandexTrackerSaveTasksResponse,
  YandexTrackerAddTaskRequest,
  YandexTrackerAddTaskResponse,
  YandexTrackerSyncRequest,
  YandexTrackerSyncResponse,
  YandexTrackerSyncStatusRequest,
  YandexTrackerSyncStatusResponse,
  YandexTrackerDeleteTaskRequest,
  YandexTrackerDeleteTaskResponse,
  YandexTrackerQueuesResponse,
  YandexTrackerQueuesSyncRequest,
  YandexTrackerQueuesSyncResponse,
  YandexTrackerGroupsRequest,
  YandexTrackerGroupsResponse,
  YandexTrackerGroupTasksRequest,
  YandexTrackerGroupTasksResponse,
} from './types';

const BASE = 'yandex/tracker';

function queryString(params: Record<string, string | number | undefined | null>): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null) search.set(k, String(v));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export class YandexTrackerApi {
  static async searchTasks(
    req: YandexTrackerSearchTasksRequest
  ): Promise<YandexTrackerSearchTasksResponse> {
    const path = `${BASE}/tasks/search${queryString(req.params)}`;
    const res = await apiReq<YandexTrackerSearchTasksResponse>(path, 'GET');
    return res ?? [];
  }

  static async saveTasks(
    req: YandexTrackerSaveTasksRequest
  ): Promise<YandexTrackerSaveTasksResponse> {
    const res = await apiReq<YandexTrackerSaveTasksResponse>(
      `${BASE}/tasks/save`,
      'POST',
      req.body
    );
    return res ?? { status: 'success' };
  }

  static async addTask(req: YandexTrackerAddTaskRequest): Promise<YandexTrackerAddTaskResponse> {
    const res = await apiReq<YandexTrackerAddTaskResponse>(`${BASE}/tasks/add`, 'POST', req.body);
    if (res == null) throw new Error('Пустой ответ при добавлении задачи');
    return res;
  }

  static async sync(req: YandexTrackerSyncRequest): Promise<YandexTrackerSyncResponse> {
    const res = await apiReq<YandexTrackerSyncResponse>(`${BASE}/tasks/sync`, 'POST', req.body);
    if (res == null) throw new Error('Пустой ответ при синхронизации');
    return res;
  }

  static async getSyncStatus(
    req: YandexTrackerSyncStatusRequest
  ): Promise<YandexTrackerSyncStatusResponse> {
    const path = `${BASE}/tasks/sync/status${queryString(req.params)}`;
    const res = await apiReq<YandexTrackerSyncStatusResponse>(path, 'GET');
    if (res == null) throw new Error('Пустой ответ статуса синхронизации');
    return res;
  }

  static async deleteTask(
    req: YandexTrackerDeleteTaskRequest
  ): Promise<YandexTrackerDeleteTaskResponse> {
    const res = await apiReq<YandexTrackerDeleteTaskResponse>(
      `${BASE}/task/${req.params.id}/delete`,
      'DELETE'
    );
    return res ?? { status: 'success' };
  }

  static async getQueues(): Promise<YandexTrackerQueuesResponse> {
    const res = await apiReq<YandexTrackerQueuesResponse>(`${BASE}/queues`, 'GET');
    return res ?? [];
  }

  static async syncQueues(
    req: YandexTrackerQueuesSyncRequest
  ): Promise<YandexTrackerQueuesSyncResponse> {
    const res = await apiReq<YandexTrackerQueuesSyncResponse>(
      `${BASE}/queues/sync`,
      'POST',
      req.body
    );
    if (res == null) throw new Error('Пустой ответ при синхронизации очередей');
    return res;
  }

  static async getGroups(req: YandexTrackerGroupsRequest): Promise<YandexTrackerGroupsResponse> {
    const path = `${BASE}/tasks/groups${queryString(req.params as unknown as Record<string, string | number | undefined | null>)}`;
    const res = await apiReq<YandexTrackerGroupsResponse>(path, 'GET');
    if (res == null) throw new Error('Пустой ответ списка групп');
    return res;
  }

  static async getGroupTasks(
    req: YandexTrackerGroupTasksRequest
  ): Promise<YandexTrackerGroupTasksResponse> {
    const { id, ...queryParams } = req.params;
    const path = `${BASE}/tasks/group/${id}/tasks${queryString(queryParams as unknown as Record<string, string | number | undefined | null>)}`;
    const res = await apiReq<YandexTrackerGroupTasksResponse>(path, 'GET');
    if (res == null) throw new Error('Пустой ответ задач группы');
    return res;
  }
}
